import { render } from "./Form.vue?vue&type=template&id=03322c6f&scoped=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=03322c6f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-03322c6f"

export default script